import { render, staticRenderFns } from "./UpdateOrCreateVenueComponent.vue?vue&type=template&id=8b5684e0&scoped=true"
import script from "./UpdateOrCreateVenueComponent.vue?vue&type=script&lang=js"
export * from "./UpdateOrCreateVenueComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5684e0",
  null
  
)

export default component.exports